__webpack_require__.p = "/mysponsorship/";